(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRotator = (root) => {
      if (root.dataset.abInit === 'true') return;
      root.dataset.abInit = 'true';

      const items = Array.from(root.querySelectorAll('.announcement-item'));
      if (items.length < 2) return;

      const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speedSec = Number(root.dataset.speed || 5);
      const intervalMs = Math.max(3, speedSec) * 1000;
      const animMs = prefersReduced ? 0 : 450;

      let index = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));

      const go = (nextIndex) => {
        if (nextIndex === index) return;
        const current = items[index];
        const next = items[nextIndex];

        current.classList.remove('ab-entering');
        current.classList.add('ab-leaving');

        next.classList.remove('ab-leaving');
        next.classList.add('is-active', 'ab-entering');
        next.setAttribute('aria-hidden', 'false');

        window.setTimeout(() => {
          current.classList.remove('is-active', 'ab-leaving');
          current.setAttribute('aria-hidden', 'true');
          next.classList.remove('ab-entering');
          index = nextIndex;
        }, animMs);
      };

      const tick = () => {
        if (!root.isConnected) return;
        if (document.hidden) {
          window.setTimeout(tick, intervalMs);
          return;
        }
        go((index + 1) % items.length);
        window.setTimeout(tick, intervalMs);
      };

      window.setTimeout(tick, intervalMs);
    };

    const initAll = () => document.querySelectorAll('.announcement-rotator').forEach(initRotator);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initAll);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
